export default function AuthAdminDashboard({ contentData, initError, initLoader }) {
  return <div>This is Auth Admin Dashboard page</div>;
}
